import { createContext } from "react";

const ReleaseContext = createContext();

export default ReleaseContext;
